import React from 'react'

import { SectionContainer } from 'Components/Blocks'
import { Row, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container } from './styles'

function ThankYouInfoSection() {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer>
      <Row fullWidth justifyCenter px={LANDING_CONTENT_PX}>
        <Container>
          <Text regular screen16={isMobile} screen20={!isMobile} secondary>
            Thank you for taking the time to complete the data fields required
            to set up your membership, it is important to set up your profile
            and industry information so that we can best leverage your
            connection to the Emajin community.
            <br />
            <br />
            Our customer management team will be contacting you to set up a time
            to finalise your membership activation. During the quick personal
            call, we will confirm the details you have provided and share
            details of our upcoming events and activities so that you can start
            taking advantage of your membership.
            <br />
            <br />
            In the meantime, if you have any questions, please do not hesitate
            to contact us.
          </Text>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default ThankYouInfoSection
